import { Model, Attr, BelongsTo, HasMany } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'
import Caretaker from '@/models/Caretaker'
import Program from '@/models/Program'
import MultiChoiceGiftCard from '@/models/MultiChoiceGiftCard'
import DotationOperation from '@/models/DotationOperation'
import UrsafEvent from '@/models/UrsafEvent'
import MultiChoiceCardOrderLine from '@/models/MultiChoiceCardOrderLine'

@Model()
export default class MultiChoiceCardOrder extends ApplicationRecord {
  static jsonapiType = 'multi_choice_card_orders'

  @Attr() id!: string
  @Attr() number!: string
  @Attr() amount!: number
  @Attr() amountCents!: number
  @Attr() expireAt!: string | null
  @Attr() status!: string
  @Attr() confirmedAt!: string | null
  @Attr() payedAt!: string | null
  @Attr() scheduledAt!: string | null
  @Attr() caretakerIssuanceCharge!: number
  @Attr() caretakerLoadingCharge!: number
  @Attr() programId!: string
  @Attr() multiChoiceGiftCardId!: string
  @Attr() dotationOperationId!: string
  @Attr() caretakerId!: string
  @Attr() ursafEventId!: string
  @Attr() createdAt!: string
  @Attr() updatedAt!: string

  @BelongsTo() caretaker!: Caretaker
  @BelongsTo() program!: Program
  @BelongsTo() multiChoiceGiftCard!: MultiChoiceGiftCard
  @BelongsTo() dotationOperation!: DotationOperation
  @BelongsTo() ursafEvent!: UrsafEvent
  @HasMany() multiChoiceCardOrderLines!: MultiChoiceCardOrderLine[]
}
